import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { UserAddressData, UserProfileData } from "../../../../../Data/Applications/Users/Users";
import { H6 } from "../../../../../AbstractElements";

export const InfoSection = () => {
  return (
    <Row className="g-3">
      <Col sm="6" lg="4" className="order-sm-1 order-xl-0">
        <Row>
          {UserProfileData.map(({ iconClass, text, spanText }, index) => (
            <Col md="6" key={index}>
              <div className="ttl-info text-start">
                <H6 className="mb-1"><i className={`fa fa-${iconClass} me-2`}></i>{text}</H6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
      <Col sm="12" lg="4" className="order-sm-0 order-xl-1">
        <div className="user-designation">
          <div className="title">
            <Link to={`${process.env.PUBLIC_URL}/applications/users/user-profile`}>Mark jecno</Link>
          </div>
          <div className="desc">designer</div>
        </div>
      </Col>
      <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
        <Row>
          {UserAddressData.map(({ iconClass, text, spanText }, index) => (
            <Col md="6" key={index}>
              <div className="ttl-info text-start">
                <H6 className="mb-1"><i className={`fa fa-${iconClass}`}></i>{text}</H6>
                <span>{spanText}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};